module.exports = __webpack_public_path__ + "static/img/bg.0137480.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/register/bg.jpg
// module id = xidV
// module chunks = 1